import Navbar from "../components/Navbar";
import ServiceHero from "../components/ServiceHero";
import GameServicesOverview from "../components/GameServicesOverview";
import GameFeatureCard from "../components/GameFeatureCard";
import CTA from "../components/CTA";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";

// Game Development Images
import analyticsImage from "../assets/game-development/Analytics.png";
import customFeaturesImage from "../assets/game-development/CustomGameFeature.png";
import debuggingImage from "../assets/game-development/BugFix.png";
import endToEndImage from "../assets/game-development/EndtoEnd.png";
import environmentImage from "../assets/game-development/Environment.jpg.jpeg";
import localizationImage from "../assets/game-development/Localization.png";
import multiplayerImage from "../assets/game-development/multiplayer.png";
import prototypeImage from "../assets/game-development/Gameprototype.png";
import uiUxImage from "../assets/game-development/UIUX.png";
import unityTool from "../assets/game-development/UnityTools.png";
import vfxImage from "../assets/game-development/VFX.jpg.jpeg";


const GameDevelopment = () => {

  return (
    <>
      <Navbar />

      <ServiceHero
        title="Game Development"
        subtitle="From prototypes to multiplayer experiences, we build high-quality Unity games optimized for every platform."
      />

      <GameServicesOverview />

      <section className="game-features">

        <div className="game-features-container">

          {/* =========================================
              END-TO-END GAME DEVELOPMENT
          ========================================= */}

          <GameFeatureCard
            badge="GAME DEVELOPMENT"
            title="End-to-End Game Development"
            description="We transform your game idea into a polished product by handling every stage of development—from planning and gameplay systems to optimization, publishing and post-launch support."
            features={[
              "Unity Development",
              "Cross Platform",
              "Mobile & PC",
              "Publishing"
            ]}
            image={endToEndImage}
            reverse={false}
            whatsappMessage="Hi! I'm interested in your End-to-End Game Development service. I'd like to discuss my game idea."
          />


          {/* =========================================
              UNITY TOOLS
              IMAGE WILL BE ADDED LATER
          ========================================= */}

          <GameFeatureCard
            badge="UNITY TOOLS"
            title="Unity Tools"
            description="Boost productivity with custom Unity Editor extensions and workflow automation tools that speed up development and simplify repetitive tasks."
            features={[
              "Editor Extensions",
              "Workflow Automation",
              "Custom Inspectors",
              "Asset Store Tools"
            ]}
            image={unityTool}
            reverse={true}
            whatsappMessage="Hi! I'm interested in your Unity Tools development service. I'd like to discuss my requirements."
          />


          {/* =========================================
              GAME UI DESIGN
          ========================================= */}

          <GameFeatureCard
            badge="UI / UX"
            title="Game UI Design"
            description="Design immersive and intuitive user interfaces that enhance gameplay while maintaining a polished visual experience."
            features={[
              "HUD Design",
              "Inventory",
              "Menus",
              "Player Experience"
            ]}
            image={uiUxImage}
            reverse={false}
            whatsappMessage="Hi! I'm interested in your Game UI Design service. I'd like to discuss my project."
          />


          {/* =========================================
              ENVIRONMENT DESIGN
          ========================================= */}

          <GameFeatureCard
            badge="WORLD BUILDING"
            title="Environment Design"
            description="Create immersive worlds with optimized environments, lighting, terrain, and level design tailored to your game's style."
            features={[
              "Level Design",
              "Terrain",
              "Lighting",
              "World Building"
            ]}
            image={environmentImage}
            reverse={true}
            whatsappMessage="Hi! I'm interested in your Environment Design service. I'd like to discuss my game."
          />


          {/* =========================================
              CUSTOM GAME FEATURES
          ========================================= */}

          <GameFeatureCard
            badge="GAMEPLAY"
            title="Custom Game Features"
            description="Need a unique gameplay mechanic? We build custom systems designed specifically around your game."
            features={[
              "Custom Mechanics",
              "AI Systems",
              "Inventory",
              "Save Systems"
            ]}
            image={customFeaturesImage}
            reverse={false}
            whatsappMessage="Hi! I'm interested in your Custom Game Features service. I'd like to discuss my project."
          />


          {/* =========================================
              MULTIPLAYER
          ========================================= */}

          <GameFeatureCard
            badge="MULTIPLAYER"
            title="Multiplayer"
            description="Real-time multiplayer with matchmaking, synchronization, lobbies and cross-platform networking."
            features={[
              "Photon",
              "Unity Netcode",
              "Matchmaking",
              "Lobby Systems"
            ]}
            image={multiplayerImage}
            reverse={true}
            whatsappMessage="Hi! I'm interested in your Multiplayer Game Development service. I'd like to discuss my project."
          />


          {/* =========================================
              VISUAL EFFECTS
          ========================================= */}

          <GameFeatureCard
            badge="VISUAL EFFECTS"
            title="Visual Effects"
            description="Beautiful particles, shaders, magic effects and cinematic visuals that elevate gameplay."
            features={[
              "Particles",
              "Shader Graph",
              "Magic FX",
              "Post Processing"
            ]}
            image={vfxImage}
            reverse={false}
            whatsappMessage="Hi! I'm interested in your Visual Effects service for my game. I'd like to discuss my requirements."
          />


          {/* =========================================
              GAME DEBUG & OPTIMIZATION
          ========================================= */}

          <GameFeatureCard
            badge="OPTIMIZATION"
            title="Game Debug & Optimization"
            description="Improve performance, eliminate bugs and ensure a smooth gameplay experience on every platform."
            features={[
              "FPS Boost",
              "Bug Fixes",
              "Memory",
              "Profiling"
            ]}
            image={debuggingImage}
            reverse={true}
            whatsappMessage="Hi! I'm interested in your Game Debug & Optimization service. I'd like to discuss my project."
          />


          {/* =========================================
              GAME PROTOTYPE
          ========================================= */}

          <GameFeatureCard
            badge="PROTOTYPE"
            title="Game Prototype"
            description="Rapid prototype development to validate ideas, test gameplay mechanics and pitch to investors."
            features={[
              "Rapid Development",
              "MVP",
              "Testing",
              "Prototype Build"
            ]}
            image={prototypeImage}
            reverse={false}
            whatsappMessage="Hi! I'm interested in your Game Prototype development service. I'd like to discuss my idea."
          />


          {/* =========================================
              GAME ANALYTICS
          ========================================= */}

          <GameFeatureCard
            badge="ANALYTICS"
            title="Game Analytics"
            description="Track player behaviour, events and retention using powerful analytics solutions."
            features={[
              "Firebase",
              "Player Events",
              "Retention",
              "Reports"
            ]}
            image={analyticsImage}
            reverse={true}
            whatsappMessage="Hi! I'm interested in your Game Analytics service. I'd like to discuss my project."
          />


          {/* =========================================
              GAME LOCALIZATION
          ========================================= */}

          <GameFeatureCard
            badge="LOCALIZATION"
            title="Game Localization"
            description="Reach players worldwide with multilingual support and localization-ready systems."
            features={[
              "Languages",
              "RTL",
              "Localization",
              "Dynamic Fonts"
            ]}
            image={localizationImage}
            reverse={false}
            whatsappMessage="Hi! I'm interested in your Game Localization service. I'd like to discuss my game."
          />

        </div>

      </section>

      <CTA />

      <Footer />

      <WhatsAppButton />

    </>
  );
};

export default GameDevelopment;